import { render, staticRenderFns } from "./jurisd.vue?vue&type=template&id=0b30e45b&scoped=true"
import script from "./jurisd.vue?vue&type=script&lang=js"
export * from "./jurisd.vue?vue&type=script&lang=js"
import style0 from "./jurisd.vue?vue&type=style&index=0&id=0b30e45b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b30e45b",
  null
  
)

export default component.exports